import { Button, Center, Stack, Text, ThemeIcon, Title } from '@mantine/core';
import { IconLock, IconMapQuestion } from '@tabler/icons-react';
import { Link } from 'react-router';
import { useAuth } from '@/auth/AuthProvider';
import { homeFor } from '@/lib/paths';

export function ForbiddenPage() {
  const { user } = useAuth();
  return (
    <Center py={80}>
      <Stack align="center" gap="sm" maw={420} ta="center">
        <ThemeIcon size={56} radius="xl" variant="light" color="orange">
          <IconLock size={28} />
        </ThemeIcon>
        <Title order={3}>You don't have access to this page</Title>
        <Text c="dimmed" fz="sm">
          Your role does not include this area. If you need it for your work, ask an administrator to update your access.
        </Text>
        <Button component={Link} to={homeFor(user)} variant="light">
          Back to dashboard
        </Button>
      </Stack>
    </Center>
  );
}

export function NotFoundPage() {
  const { user } = useAuth();
  const client = user?.userType === 'exporter';
  return (
    <Center py={80}>
      <Stack align="center" gap="sm" maw={420} ta="center">
        <ThemeIcon size={56} radius="xl" variant="light" color="gray">
          <IconMapQuestion size={28} />
        </ThemeIcon>
        <Title order={3}>Page not found</Title>
        <Text c="dimmed" fz="sm">
          The link may be old, or the item was removed.
        </Text>
        <Button component={Link} to={homeFor(user)} variant="light">
          {client ? 'Back to your requests' : 'Back to dashboard'}
        </Button>
      </Stack>
    </Center>
  );
}
